<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            CONTRATO -
                            <strong
                                >{{ contrato.vcCodigoEstruturado }} -
                                {{
                                    contrato.fornecedor
                                        ? contrato.fornecedor.nome
                                        : ''
                                }}</strong
                            >
                            <b-badge variant="warning" class="ml-2">{{
                                operacao
                            }}</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>
                        <b-tabs pills card vertical v-model="tabIndex">
                            <b-tab title="Dados Gerais" active class="pb-0">
                                <app-contrato-dados-gerais
                                    v-if="$temAcessoView('CONT-01')"
                                    :contrato="contrato"
                                ></app-contrato-dados-gerais>
                            </b-tab>
                            <b-tab title="Itens de Contrato" class="pb-0">
                                <app-itens-contrato
                                    :contrato="contrato"
                                    @obterContratoAtualizado="
                                        obterContratoAtualizado(true)
                                    "
                                ></app-itens-contrato>
                            </b-tab>
                            <b-tab title="Engenharia" class="pb-0" v-if="$temAcessoView('CONT-ENG-01')">
                                <app-engenharia
                                    :dadosEngenharia="dadosEngenharia"
                                ></app-engenharia>
                            </b-tab>
                            <b-tab title="Documentos" class="pb-0">
                                <app-documentos
                                    :contrato="contrato"
                                    @obterDocumentosAtualizados="
                                        obterDocumentosAtualizados()
                                    "
                                ></app-documentos>
                            </b-tab>
                            <b-tab title="Responsáveis" class="pb-0">
                                <app-contrato-responsaveis
                                    :contrato="contrato"
                                    @obterResponsaveisAtualizados="
                                        obterResponsaveisAtualizados()
                                    "
                                ></app-contrato-responsaveis>
                            </b-tab>
                            <b-tab title="Dados RM" class="pb-0">
                                <AppDadosRm
                                    v-if="$temAcessoView('CONT-01')"
                                    :contrato="contrato"
                                ></AppDadosRm>
                            </b-tab>
                            <b-tab title="Fases do Contrato" class="pb-0">
                                <app-fases-contrato
                                    :contrato="contrato"
                                    @obterFasesAtualizadas="
                                        obterFasesAtualizadas()
                                    "
                                    @obterApostilamentosAtualizados="
                                        obterApostilamentosAtualizados()
                                    "
                                    @obterComprometimentosAtualizados="
                                        obterComprometimentosAtualizados()
                                    "
                                    @obterContratoAtualizado="
                                        obterContratoAtualizado(true)
                                    "
                                ></app-fases-contrato>
                            </b-tab>
                            <b-tab title="Dotações Orçamentárias" class="pb-0">
                                <app-dotacoes-orcamentarias
                                    :contrato="contrato"
                                    @obterDotacoesAtualizadas="
                                        obterDotacoesAtualizadas()
                                    "
                                ></app-dotacoes-orcamentarias>
                            </b-tab>
                            <b-tab
                                title="Comprometimentos"
                                class="pb-0"
                                v-if="
                                    !contratoElaboracao &&
                                    !aditivoContratoIniciado &&
                                    $temAcessoView('CONT-COMPR-00')
                                "
                            >
                                <comprometimentos
                                    ref="comprometimentos"
                                    :contrato="contrato"
                                ></comprometimentos>
                            </b-tab>
                            <!-- <b-tab title="Aditivos" class="pb-0" :disabled="true"></b-tab> -->
                            <b-tab
                                title="Apostilamento"
                                class="pb-0"
                                v-if="
                                    !contratoElaboracao &&
                                    !aditivoContratoIniciado
                                "
                            >
                                <app-contrato-apostilamentos
                                    :contrato="contrato"
                                ></app-contrato-apostilamentos>
                            </b-tab>
                            <b-tab
                                title="Ocorrências Internas"
                                class="pb-0"
                                v-if="
                                    !contratoElaboracao &&
                                    !aditivoContratoIniciado
                                "
                            >
                                <ocorrencias-internas
                                    :contrato="contrato"
                                ></ocorrencias-internas>
                            </b-tab>
                            <b-tab
                                title="Penalidades"
                                class="pb-0"
                                v-if="
                                    $temAcessoView('CONT-PENAL-00') &&
                                    !contratoElaboracao &&
                                    !aditivoContratoIniciado
                                "
                            >
                                <penalidades
                                    :contrato="contrato"
                                    @atualizarPenalidades="
                                        contrato.penalidades = $event
                                    "
                                ></penalidades>
                            </b-tab>
                            <b-tab title="Processos Judiciais" class="pb-0">
                                <processos-judiciais
                                    :contrato="contrato"
                                    @atualizarProcessos="
                                        contrato.processosJudiciais = $event
                                    "
                                ></processos-judiciais>
                            </b-tab>
                            <b-tab
                                title="Histórico"
                                class="pb-0"
                                v-if="contrato.qtdAditivos > 0"
                            >
                                <historico-aditivos
                                    :contrato="contrato"
                                ></historico-aditivos>
                            </b-tab>

                            <b-tab
                                title="Histórico de Usuário e Alterações"
                                class="pb-0"
                            >
                                <historico-usuario
                                    :contrato="contrato"
                                ></historico-usuario>
                            </b-tab>

                            <b-tab
                                title="Alertas"
                                class="pb-0"
                                v-if="mostrarAlerta"
                            >
                                <alertas-vigencia
                                    :contrato="contrato"
                                ></alertas-vigencia>
                            </b-tab>
                            <b-tab title="Melhorias e Manutenções" class="pb-0">
                                <manutencoesContratos
                                    :contrato="contrato"
                                    @atualizarManutencoes="
                                        contrato.manutencoes = $event
                                    "
                                ></manutencoesContratos>
                            </b-tab>
                            <b-tab
                                title="Histórico de Erro de Integração"
                                class="pb-0"
                            >
                                <historico-job-integracao
                                    :contrato="contrato"
                                ></historico-job-integracao>
                            </b-tab>
                            <b-tab title="Seguros/Melhorias" class="pb-0">
                                <seguros
                                    :contrato="contrato"
                                    @atualizarSeguros="
                                        contrato.segurosGarantias = $event
                                    "
                                    @atualizarEngenharia="obterEngenharia()"
                                ></seguros>
                            </b-tab>
                            <b-tab title="Investimentos" class="pb-0">
                                <investimentos
                                    :contrato="contrato"
                                    @atualizarInvestimentos="
                                        contrato.investimentosPrevistos = $event
                                    "
                                ></investimentos>
                            </b-tab>
                            <b-tab title="Movimentações Mínimas" class="pb-0">
                                <movimentacoesMinimas
                                    :contrato="contrato"
                                    @atualizarMovimentacoes="
                                        contrato.movimentacoesMinimaContrato =
                                            $event
                                    "
                                ></movimentacoesMinimas>
                            </b-tab>
                            <!-- <b-tab title="Avaliações" class="pb-0" :disabled="true"></b-tab> -->
                        </b-tabs>
                    </b-card-body>
                    <b-card-footer>
                        <b-button variant="danger" @click.stop="voltar()">
                            <span>
                                <i class="fa fa-history mr-2"></i> Voltar
                            </span>
                        </b-button>
                        <b-button
                            variant="primary"
                            @click.stop="apostilarContrato()"
                            class="ml-1"
                            v-if="mostrarBtnApostilar"
                        >
                            <span>
                                <i class="fa fa-edit mr-2"></i> Apostilar dados
                                gerais
                            </span>
                        </b-button>
                        <b-button
                            variant="primary"
                            @click.stop="AtualizarContrato()"
                            class="ml-1"
                            v-if="mostrarBtnAtualizarElab"
                        >
                            <span>
                                <i class="fa fa-edit mr-2"></i> Atualizar
                            </span>
                        </b-button>
                        <b-button
                            variant="primary"
                            @click.stop="AtualizarDadosRM()"
                            class="ml-1"
                            v-if="mostrarBtnAtualizarDadosRM"
                        >
                            <span>
                                <i class="fa fa-edit mr-2"></i> Atualizar
                            </span>
                        </b-button>
                        <b-button
                            variant="warning"
                            @click.stop="AtualizarEngenharia()"
                            class="ml-1"
                            v-if="mostrarBtnAtualizarEngenharia"
                        >
                            <span>
                                <i class="fa fa-edit mr-2"></i> Atualizar
                            </span>
                        </b-button>
                        <b-button
                            variant="primary"
                            @click.stop="AtualizarContrato()"
                            class="ml-1"
                            v-if="mostrarBtnAtualizarAditivo"
                        >
                            <span>
                                <i class="fa fa-edit mr-2"></i> Atualizar
                            </span>
                        </b-button>
                        <btn-alternar-contrato
                            :contrato="contrato"
                            @obterContratoAtualizado="
                                obterContratoAtualizado(true)
                            "
                            @retornarParaLista="retornarParaLista(true)"
                            @atualizarMensagensErros="erros = $event"
                            v-if="mostrarBtnAlternarContrato"
                        ></btn-alternar-contrato>
                        <btn-encerrar-contrato
                            :contrato="contrato"
                            @obterContratoAtualizado="
                                obterContratoAtualizado(true)
                            "
                            @atualizarMensagensErros="erros = $event"
                            v-if="mostrarBtnEncerrarContrato"
                        ></btn-encerrar-contrato>
                        <btn-cancelar-contrato
                            :contrato="contrato"
                            @obterContratoAtualizado="
                                obterContratoAtualizado(true)
                            "
                            @atualizarMensagensErros="erros = $event"
                            v-if="mostrarBtnCancelarContrato"
                        ></btn-cancelar-contrato>
                        <btn-distribuir-contrato
                            :contrato="contrato"
                            v-if="mostrarBtnDistribuirContrato"
                            @obterContratoAtualizado="
                                obterContratoAtualizado(true)
                            "
                        >
                        </btn-distribuir-contrato>
                        <btn-distribuir-aditivo-contrato
                            :contrato="contrato"
                            v-if="mostrarBtnDistribuirAditivoContrato"
                            @obterContratoAtualizado="
                                obterContratoAtualizado(true)
                            "
                        >
                        </btn-distribuir-aditivo-contrato>
                        <b-button
                            variant="primary"
                            @click.stop="AditivarContrato()"
                            class="ml-1"
                            v-if="mostrarBtnAditivarContrato"
                        >
                            <span>
                                <i class="fa fa-plus mr-2"></i> Iniciar aditivo
                                contrato
                            </span>
                        </b-button>
                        <btn-integrar-contrato
                            :contrato="contrato"
                            v-if="mostrarBtnIntegrarContrato"
                            @obterContratoAtualizado="
                                obterContratoAtualizado(true)
                            "
                            @mostrarErros="mostrarErros($event)"
                        >
                        </btn-integrar-contrato>
                        <btn-integrar-aditivo-contrato
                            :contrato="contrato"
                            v-if="mostrarBtnIntegrarAditivoContrato"
                            @obterContratoAtualizado="
                                obterContratoAtualizado(true)
                            "
                        >
                        </btn-integrar-aditivo-contrato>
                        <b-button
                            variant="primary"
                            @click.stop="AtualizarSemApostilar()"
                            class="ml-1"
                            v-if="mostrarBtnAtualizar"
                        >
                            <span>
                                <i class="fa fa-edit mr-2"></i> Atualizar dados
                                gerais
                            </span>
                        </b-button>
                        <b-button
                            variant="primary"
                            @click.stop="gerarRelatorioCircunstanciado()"
                            class="ml-1"
                            v-if="verificaEmitirRelatorio"
                        >
                            <span>
                                <i class="fa fa-print mr-2"></i>
                                Emitir relatório circunstanciado
                            </span>
                        </b-button>
                        <b-checkbox
                            class="pull-right"
                            v-if="mostrarCheckContratoComprovacao"
                            v-model="contratoComprovacao"
                            @change="selecionaContratoComprovacao($event)"
                            >Contrato com comprovação</b-checkbox
                        >
                        <b-dropdown
                            class="ml-1"
                            toggle-class="btn btn-warning"
                            v-if="mostrarBtnRetornarEtapaAnterior"
                        >
                            <template #button-content>
                                <span
                                    ><i class="fa fa-refresh mr-2"></i> Retornar
                                    para etapa anterior
                                </span>
                            </template>
                            <b-dropdown-item
                                v-for="item in opcoesMenu"
                                :key="item.id"
                                @click="confirmarMudancaDeFase(item)"
                            >
                                {{ item.nome }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import ContratosServicos from './ContratosServicos'
import DocumentosServicos from './documentos/DocumentosServicos'
import ContratoDadosGerais from './ContratoDadosGerais'
import ContratoApostilamentos from './apostilamento/ContratoApostilamentos'
import DotacoesOrcamentarias from './dotacoesOrcamentarias/DotacoesOrcamentarias'
import ContratoResponsaveis from './responsaveis/ContratoResponsaveis'
import ItensContrato from './ItensContrato/ItensContrato'
import FasesContrato from './fasesContrato/FasesContrato'
import Documentos from './documentos/Documentos'
import BtnEncerrarContrato from './BtnEncerrarContrato'
import BtnCancelarContrato from './BtnCancelarContrato'
import BtnAlternarContrato from './BtnAlternarContrato'
import BtnDistribuirContrato from './BtnDistribuirContrato'
import BtnDistribuirAditivoContrato from './BtnDistribuirAditivoContrato'
import BtnIntegrarContrato from './BtnIntegrarContrato'
import BtnIntegrarAditivoContrato from './BtnIntegrarAditivoContrato'
import OcorrenciasInternas from './ocorrenciasInternas/OcorrenciasInternas'
import Penalidades from './penalidades/Penalidades'
import ManutencoesContratos from './manutencoesContratos/ManutencoesContratos'
import Comprometimentos from './comprometimentos/Comprometimentos'
import DadosRm from './dadosRM/dadosRM'
import { situacaoContrato } from './SituacaoContrato'
import HistoricoAditivos from './historicoAditivos/HistoricoAditivos'
import AlertasVigencia from './alertas/AlertasVigencia'
import ProcessosJudiciais from './processosJudiciais/ProcessosJudiciais.vue'
import Investimentos from './investimentos/Investimentos'
import Seguros from './seguros/Seguros.vue'
import MovimentacoesMinimas from './movimentacoesMinimas/MovimentacoesMinimas.vue'
import HistoricoUsuario from './historicoUsuario/HistoricoUsuario.vue'
import HistoricoJobIntegracao from './historicoJobIntegracao/HistoricoJobIntegracao.vue'
import Engenharia from './engenharia/engenharia'
import BtnDeflatorContrato from './BtnDeflatorContrato.vue'


export default {
    components: {
        AppContratoDadosGerais: ContratoDadosGerais,
        AppDadosRm: DadosRm,
        AppContratoApostilamentos: ContratoApostilamentos,
        AppContratoResponsaveis: ContratoResponsaveis,
        AppItensContrato: ItensContrato,
        AppFasesContrato: FasesContrato,
        AppDotacoesOrcamentarias: DotacoesOrcamentarias,
        AppDocumentos: Documentos,
        BtnEncerrarContrato,
        BtnCancelarContrato,
        BtnAlternarContrato,
        BtnDistribuirContrato,
        BtnDistribuirAditivoContrato,
        BtnIntegrarContrato,
        BtnIntegrarAditivoContrato,
        OcorrenciasInternas,
        Penalidades,
        Comprometimentos,
        HistoricoAditivos,
        AlertasVigencia,
        ProcessosJudiciais,
        ManutencoesContratos,
        Investimentos,
        Seguros,
        MovimentacoesMinimas,
        HistoricoUsuario,
        HistoricoJobIntegracao,
        AppEngenharia: Engenharia,
        BtnDeflatorContrato
    },

    data() {
        return {
            contrato: {},
            dadosRm: {},
            dadosEngenharia: {},
            contratoComprovacao: false,
            operacao: 'DETALHAR',
            tabIndex: 0,
            erros: [],
            situacaoContrato: situacaoContrato,
            opcoesMenu: [],
            todasOpcoesMenu: [
                {
                    id: situacaoContrato.PRE_CONTRATO_EM_ELABORACAO,
                    nome: 'Pré-contrato em elaboração'
                },
                {
                    id: situacaoContrato.PRE_CONTRATO_CONCLUIDO,
                    nome: 'Pré-contrato concluído'
                },
                {
                    id: situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO,
                    nome: 'Contrato distribuído aguardando integração'
                },
                {
                    id: situacaoContrato.ADITIVO_AGUARDANDO_JOB_DE_INTEGRACAO,
                    nome: 'Contrato aguardando job de integração'
                },
                {
                    id: situacaoContrato.CONTRATO_DISTRIBUIDO,
                    nome: 'Contrato distribuído'
                },
                {
                    id: situacaoContrato.INICIADO_ADITIVO_CONTRATO,
                    nome: 'Iniciado aditivo de contrado'
                },
            ]
        }
    },

    methods: {
        voltar() {
            this.$router.push({ name: 'Contratos' })
            this.$store.dispatch('setRecarregar', true)
        },

        obterContrato() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterPorId(this.$route.params.contratoId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.contrato = response.data
                            this.contratoComprovacao =
                                this.contrato.tipoEspecial
                            this.obterHistoricoJobIntegracao()
                            this.obterEngenharia()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterHistoricoJobIntegracao() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterHistoricoJobIntegracao(this.contrato)
                .then((response) => {
                    if (response && response.success) {
                        // Usar Vue.set para garantir reatividade
                        this.$set(
                            this.contrato,
                            'historicoJobIntegracao',
                            response.data
                        )
                    }
                    this.$store.dispatch('removeRequest')
                })
                .catch((error) => {
                    this.$store.dispatch('removeRequest')
                })
        },

        obterEngenharia() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterEngenharia(this.contrato.idContrato)
                .then((response) => {
                    if (response && response.success) {
                        this.dadosEngenharia = response.data || {}
                        this.$store.dispatch('setDadosEngenharia', response.data || {})
                    }
                    this.$store.dispatch('removeRequest')
                })
                .catch((error) => {
                    this.$store.dispatch('removeRequest')
                })
        },

        isSituacaoErroJob() {
            const situacoesErroJob = [
                'ERRO NO JOB',
                'ERRO_INTEGRACAO',
                'FALHA NA MIGRAÇÃO',
                'FALHA PARA MIGRAÇÃO',
                'ERROAPI',
                'ERROINTERNO',
                'ERROSISTEMAREMOTO',
                'FALHA NA ATUALIZAÇÃO',
                'FALHAAOREALIZARCONSULTA'
            ]

            return (
                this.contrato &&
                this.contrato.situacaoContrato &&
                situacoesErroJob.some((situacao) =>
                    this.contrato.situacaoContrato
                        .toUpperCase()
                        .includes(situacao.toUpperCase())
                )
            )
        },

        obterResponsaveisAtualizados() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterResponsaveisPorContrato(
                this.$route.params.contratoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.contrato.responsaveisContrato = response.data
                        this.obterApostilamentosAtualizados()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterDotacoesAtualizadas() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterDotacoesPorContrato(
                this.$route.params.contratoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.contrato.dotacoesOrcamentarias = response.data
                        this.obterApostilamentosAtualizados()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterFasesAtualizadas() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterFasesPorContrato(
                this.$route.params.contratoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.contrato.fasesContrato = response.data.fases
                        this.contrato.totalFases = response.data.totalFases
                        this.contrato.valorDisponivelFases =
                            response.data.valorDisponivelFases
                        this.obterApostilamentosAtualizados()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterDocumentosAtualizados() {
            this.$store.dispatch('addRequest')
            DocumentosServicos.obterDocumentos(
                this.$route.params.contratoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.contrato.documentosContrato = response.data
                        this.obterApostilamentosAtualizados()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterApostilamentosAtualizados() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterApostilamentosContrato(
                this.$route.params.contratoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.contrato.apostilamentos = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterComprometimentosAtualizados() {
            this.$refs.comprometimentos.obterComprometimentosBase()
        },

        obterContratoAtualizado(atualizarTabela) {
            if (atualizarTabela) {
                this.$store.dispatch('setRecarregar', true)
            }
            this.obterContrato()
        },

        retornarParaLista(atualizarTabela) {
            if (atualizarTabela) {
                this.$store.dispatch('setRecarregar', true)
            }
            this.$router.push({ name: 'Contratos' })
        },

        apostilarContrato() {
            this.$router.push({
                name: 'Contratos_Apostilar',
                params: {
                    contratoId: this.$route.params.contratoId,
                    apostilar: true
                }
            })
        },

        AtualizarContrato() {
            this.$router.push({
                name: 'Contratos_Atualizar',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        },

        AtualizarSemApostilar() {
            this.$router.push({
                name: 'Contratos_Atualizar_Sem_Apostilar',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        },

        AtualizarDadosRM() {
            this.$router.push({
                name: 'Contratos_Atualizar_DadosRM',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        },

        AtualizarEngenharia() {
            this.$router.push({
                name: 'Contratos_Atualizar_Engenharia',
                params: {
                    contratoId: this.$route.params.contratoId
                },
                state: {
                    contrato: {
                        idContrato: this.contrato.idContrato,
                        vcCodigoEstruturado: this.contrato.vcCodigoEstruturado,
                        fornecedor: this.contrato.fornecedor ? {
                            nome: this.contrato.fornecedor.nome
                        } : null
                    }
                }
            })
        },

        AditivarContrato() {
            this.$router.push({
                name: 'Contratos_Aditivar',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        },

        dotacaoOrcamentariaForm() {
            this.$router.push({
                name: 'Contratos_Dotacao',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        },

        selecionaContratoComprovacao(isTipoEspecial) {
            ContratosServicos.atualizarContratoComprovacao(
                this.contrato,
                isTipoEspecial
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Contrato com comprovação atualizado!',
                            'OK',
                            this.$toastConfig.success
                        )
                    } else {
                        this.erros = response.errors
                    }
                }
                // this.$store.dispatch('removeRequest')
            })
        },

        gerarRelatorioCircunstanciado() {
            this.$store.dispatch('addRequest')
            ContratosServicos.downloadRelatorioCircunstanciado(
                this.contrato
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao realizar download do arquivo!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(
                            response,
                            `relatorio-circunstanciado-${this.contrato.contratoRM}.pdf`
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        mostrarErros(erros) {
            this.erros = erros
        },

        determinarOpcoesMenu(contrato) {
            var itens = []
            switch (contrato.idSituacaoContrato) {
                case situacaoContrato.PRE_CONTRATO_CONCLUIDO:
                    itens = this.todasOpcoesMenu.filter(
                        (item, index) => index < 1
                    )
                    break
                case situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO:
                    itens = this.todasOpcoesMenu.filter(
                        (item, index) => index < 2
                    )
                    break
                case situacaoContrato.ADITIVO_AGUARDANDO_JOB_DE_INTEGRACAO:
                    itens = this.todasOpcoesMenu.filter(
                        (item, index) => index < 3
                    )
                    break
                case situacaoContrato.CONTRATO_DISTRIBUIDO:
                    itens = this.todasOpcoesMenu.filter(
                        (item, index) => index < 4
                    )
                    break
                case situacaoContrato.ERRO_INTEGRACAO:
                    itens = this.todasOpcoesMenu.filter(
                        (item, index) => index > 4
                    )
                    break
                default:
                    itens = this.todasOpcoesMenu
                    break
            }
            this.opcoesMenu = itens
        },

        handleClick(itemMenu) {
            this.$store.dispatch('addRequest')
            var novaEtapa = {
                idContrato: this.contrato.idContrato,
                idNovaSituacaoContrato: itemMenu.id
            }
            ContratosServicos.retornarEtapaContrato(
                this.contrato,
                novaEtapa
            ).then((response) => {
                if (response.success) {
                    this.$toast.success(
                        'Etapa retornada com sucesso!',
                        'OK',
                        this.$toastConfig.success
                    )
                    // this.recarregarDetalheContrato();
                    this.obterContrato()
                } else {
                    this.erros = response.errors
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarMudancaDeFase(itemMenu) {
            this.$swal({
                title: 'Contrato',
                html: 'Confirma o retorno para a etapa anterior?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.handleClick(itemMenu)
                }
            })
        },

        recarregarDetalheContrato() {
            this.$router.go()
        }
    },

    computed: {
        verificaDotacaoOrcamentaria() {
            let tipoContrato = this.contrato.tipoContrato.toUpperCase()

            if (tipoContrato == 'NÃO DEFINIDO') {
                return false
            }

            if (
                tipoContrato == 'MISTO' ||
                tipoContrato == 'POR ENTREGA' ||
                tipoContrato == 'PARCELA FIXA'
            ) {
                if (this.contrato.dotacoesOrcamentarias.length > 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        },

        verificaEmitirRelatorio() {
            let situacaoContrato = this.contrato.situacaoContrato

            if (
                this.tabIndex === 0 &&
                (situacaoContrato == 'Contrato Distribuído' ||
                    situacaoContrato == 'Aditivo Distribuído')
            ) {
                return true
            }

            return false
        },

        apostilamento() {
            return this.situacoesVigenteDistribuido()
        },

        encerradoCancelado() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_FINALIZADO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_CANCELADO
            )
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivoContratoIniciado() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },

        mostrarBtnApostilar() {
            return (
                this.tabIndex === 0 &&
                this.$temAcessoView('CONT-APOST-01') &&
                this.apostilamento &&
                this.contrato.contratoVigente
            )
        },

        mostrarCheckContratoComprovacao() {
            return (
                this.tabIndex === 0 &&
                this.$temAcessoView('CONT-ELAB-01') &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        mostrarBtnAtualizarElab() {
            return (
                this.tabIndex === 0 &&
                this.$temAcessoView('CONT-ELAB-00') &&
                (this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO)
            )
        },

        mostrarBtnAtualizar() {
            return (
                this.tabIndex === 0 &&
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido() &&
                this.contrato.contratoVigente
            )
        },

        mostrarBtnAtualizarDadosRM() {
            const tabIndexDadosRM = this.$temAcessoView('CONT-ENG-01') ? 5 : 4

            return (
                (this.tabIndex === tabIndexDadosRM &&
                    this.$temAcessoView('CONT-ELAB-01') &&
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO) ||
                (this.tabIndex === tabIndexDadosRM &&
                    this.$temAcessoView('CONT-ADITIV-01') &&
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO)
            )
        },

        mostrarBtnAtualizarEngenharia() {
            return (
                this.tabIndex === 2 &&
                this.$temAcessoView('CONT-ENG-02')
            )
        },

        mostrarBtnAtualizarAditivo() {
            return (
                this.tabIndex === 0 &&
                this.$temAcessoView('CONT-ADITIV-00') &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO
            )
        },

        mostrarBtnEncerrarContrato() {
            return (
                (this.apostilamento || this.contrato.isAditivo) &&
                !this.encerradoCancelado &&
                this.$temAcessoView('CONT-02') &&
                this.contrato.contratoVigente &&
                this.tabIndex === 0 &&
                (this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_VIGENTE ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.CONTRATO_DISTRIBUIDO ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.ADITIVO_VIGENTE ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.ADITIVO_DISTRIBUIDO)
            )
        },

        mostrarBtnCancelarContrato() {
            return (
                !this.apostilamento &&
                !this.encerradoCancelado &&
                !this.contrato.isAditivo &&
                this.$temAcessoView('CONT-03') &&
                this.contrato.idContrato &&
                this.tabIndex === 0 &&
                (this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_VIGENTE ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.CONTRATO_DISTRIBUIDO ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.ADITIVO_VIGENTE ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.ADITIVO_DISTRIBUIDO)
            )
        },

        mostrarBtnDistribuirContrato() {
            return (
                this.contrato.vcCodigoEstruturado != null &&
                this.contrato.fornecedor != null &&
                // this.contrato.idTipoContrato != null &&
                // this.contrato.dtInicioVigencia != null &&
                // this.contrato.dtFimVigencia != null &&
                // this.contrato.dtInicioPrazoExecucao != null &&
                // this.contrato.dtFimPrazoExecucao != null &&
                // this.contrato.dtEnvioFornecedor != null &&
                // this.contrato.dtRetornoFornecedor != null &&
                // this.contrato.dtEnvioDiretoria != null &&
                // this.contrato.dtRetornoDiretoria &&
                // this.contrato.itensContrato.length > 0 &&
                this.contrato.documentosContrato.length > 0 &&
                this.contrato.responsaveisContrato.length > 0 &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO &&
                this.tabIndex === 0
            )
        },

        mostrarBtnDistribuirAditivoContrato() {
            return (
                this.contrato.vcCodigoEstruturado != null &&
                this.contrato.fornecedor != null &&
                this.contrato.idTipoContrato != null &&
                this.contrato.dtInicioVigencia != null &&
                this.contrato.dtFimVigencia != null &&
                this.contrato.dtInicioPrazoExecucao != null &&
                this.contrato.dtFimPrazoExecucao != null &&
                this.contrato.itensContrato.length > 0 &&
                this.contrato.documentosContrato.length > 0 &&
                this.contrato.responsaveisContrato.length > 0 &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO &&
                this.tabIndex === 0
            )
        },

        mostrarBtnIntegrarContrato() {
            return (
                this.contrato.vcCodigoEstruturado != null &&
                this.contrato.fornecedor != null &&
                this.contrato.idTipoContrato != null &&
                this.contrato.dtInicioVigencia != null &&
                this.contrato.dtFimVigencia != null &&
                // this.contrato.dtInicioPrazoExecucao != null &&
                // this.contrato.dtFimPrazoExecucao &&
                // this.contrato.dtEnvioFornecedor != null &&
                // this.contrato.dtRetornoFornecedor &&
                // this.contrato.dtEnvioDiretoria != null &&
                // this.contrato.dtRetornoDiretoria &&
                this.contrato.dadosContratoRM != null &&
                this.contrato.documentosContrato.length > 0 &&
                this.contrato.responsaveisContrato.length > 0 &&
                this.contrato.totalFases > 0 &&
                this.verificaDotacaoOrcamentaria &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO &&
                this.tabIndex === 0 &&
                this.contrato.itensContrato.length > 0 &&
                this.verificarItensContrato &&
                this.$temAcessoView('CONT-ELAB-01')
            )
        },

        verificarItensContrato() {
            for (const item of this.contrato.itensContrato) {
                if (item.descTipoProduto == null) {
                    return false
                }
            }
            return true
        },

        mostrarBtnIntegrarAditivoContrato() {
            return (
                this.contrato.vcCodigoEstruturado != null &&
                this.contrato.fornecedor != null &&
                this.contrato.idTipoContrato != null &&
                this.contrato.dtInicioVigencia != null &&
                this.contrato.dtFimVigencia != null &&
                this.contrato.dtInicioPrazoExecucao != null &&
                this.contrato.dtFimPrazoExecucao &&
                this.contrato.dadosContratoRM != null &&
                this.contrato.itensContrato.length > 0 &&
                this.contrato.documentosContrato.length > 0 &&
                this.contrato.responsaveisContrato.length > 0 &&
                this.contrato.totalFases > 0 &&
                this.verificaDotacaoOrcamentaria &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO &&
                this.tabIndex === 0 &&
                this.$temAcessoView('CONT-ADITIV-01')
            )
        },

        mostrarBtnAlternarContrato() {
            return (
                this.apostilamento &&
                !this.encerradoCancelado &&
                this.$temAcessoView('CONT-04') &&
                this.contrato.ultimoContrato != null &&
                this.contrato.contratoVigente &&
                this.tabIndex === 0
            )
        },

        mostrarBtnAditivarContrato() {
            return (
                this.tabIndex === 0 &&
                (this.$temAcessoView('CONT-ADITIV-00') ||
                    this.$temAcessoView('CONT-ADITIV-01')) &&
                this.situacoesVigenteDistribuido() &&
                !this.contrato.aditivoIniciado
            )
        },

        mostrarBtnDeflatorContrato() {
            return (
                this.tabIndex === 0 &&
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido() &&
                this.contrato.contratoVigente
            )
        },

        mostrarAlerta() {
            return (
                this.contrato.dtInicioVigencia &&
                this.contrato.dtFimVigencia != null
            )
        },

        mostrarBtnRetornarEtapaAnterior() {
            // const temAutorizacaoView =
            //     this.$temAcessoView('CONT-APOST-01') ||
            //     this.$temAcessoView('CONT-ELAB-00') ||
            //     this.$temAcessoView('CONT-ELAB-01') ||
            //     this.$temAcessoView('CONT-ADITIV-00') ||
            //     this.$temAcessoView('CONT-ADITIV-01') ||
            //     this.$temAcessoView('CONT-ATUALIZAR-00')
            const etapa =
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ERRO_INTEGRACAO
            let vinculo =
                this.contrato.idSituacaoContrato ===
                situacaoContrato.ERRO_INTEGRACAO
                    ? true
                    : this.contrato.vinculoRM === false
            return (
                // temAutorizacaoView &&
                vinculo && etapa
            )
        }
    },

    created() {
        this.obterContrato()
    },

    watch: {
        $route(to) {
            if (to.name === 'Contratos_Detalhar') {
                this.obterContrato()
                this.$store.dispatch('setRecarregar', false)
                this.tabIndex = 0
            }
        },
        contrato(newValue, oldValue) {
            this.determinarOpcoesMenu(newValue)
        }
    }
}
</script>
